// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "stylesheets/" + chunkId + "." + "be822e33f2" + ".css";
};